/* ============================================================
   KN TICKET — "Casino Effect" sur ajout au panier
   • Intercepte /cart/add.js → fait revoler un billet d'entrée
   • Entrées FIXES par variant (aucun calcul) — aligné sur le webhook
   • Compteur qui monte + étincelles + glow + son optionnel
   • Bilingue via window.KN.ticket.labels (rendu par le snippet)
   ============================================================ */
(function () {
  'use strict';
  var CFG    = (window.KN && window.KN.ticket) || {};
  var L      = CFG.labels || {};
  var layer  = document.getElementById('kn-ticket-layer');
  if (!layer) return;

  /* Entrées Golf R FIXES par variant_id (mêmes valeurs que le webhook) */
  var ENTRIES = { 45384781660207: 500, 45384782807087: 1000, 45384783200303: 2500 };
  var RS3     = CFG.rs3Bonus || {};
  var reduce  = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  var busy    = false;

  /* -------- Intercept add-to-cart (toutes les sources : cartes, drawer, page produit) -------- */
  var _fetch = window.fetch;
  if (_fetch) {
    window.fetch = function () {
      var u = arguments[0]; u = (u && u.url) ? u.url : u;
      var isAdd = (typeof u === 'string') && u.indexOf('/cart/add') !== -1;
      var pr = _fetch.apply(this, arguments);
      if (isAdd) {
        pr.then(function (r) { try { return r.clone().json(); } catch (e) { return null; } })
          .then(function (d) { if (d) handleAdd(d); })
          .catch(function () {});
      }
      return pr;
    };
  }

  function handleAdd(data) {
    var item = data.items ? data.items[0] : data;       /* add.js = item direct, ou {items:[…]} en bulk */
    if (!item || !item.id) return;
    var entries = ENTRIES[item.id];
    if (!entries) return;                                /* seuls les packs déclenchent le billet (pas merch/boost) */
    showTicket({
      entries: entries,
      rs3:     RS3[item.id] || 0,
      title:   item.product_title || item.title || '',
      image:   item.image || (item.featured_image && item.featured_image.url) || ''
    });
  }

  /* -------- Rendu + animation du billet -------- */
  function showTicket(t) {
    if (busy) return; busy = true;
    var name   = (CFG.customerName && CFG.customerName.trim()) || (L.you || 'TON NOM');
    var serial = 'KNG-' + String(Date.now()).slice(-6);
    var rs3Line = t.rs3 ? '<div class="kn-tk__rs3">+ ' + fmt(t.rs3) + ' \uD83D\uDD25 AUDI RS3</div>' : '';

    var card = document.createElement('div');
    card.className = 'kn-tk';
    card.innerHTML =
      '<div class="kn-tk__glow"></div>' +
      '<div class="kn-tk__card">' +
        '<div class="kn-tk__top"><span class="kn-tk__brand">' + (L.title || "BILLET D'ENTR\u00C9E") + '</span>' +
          '<button class="kn-tk__x" type="button" aria-label="' + (L.close || 'Fermer') + '">&times;</button></div>' +
        '<div class="kn-tk__body">' +
          '<div class="kn-tk__thumb">' + (t.image ? '<img src="' + t.image + '" alt="">' : '') + '</div>' +
          '<div class="kn-tk__meta">' +
            '<span class="kn-tk__for">' + (L.issued_to || '\u00C9MIS \u00C0') + '</span>' +
            '<div class="kn-tk__name" contenteditable="true" spellcheck="false">' + esc(name) + '</div>' +
            '<span class="kn-tk__prod">' + esc(t.title) + '</span>' +
          '</div>' +
        '</div>' +
        '<div class="kn-tk__num"><span class="kn-tk__plus">+</span>' +
          '<span class="kn-tk__val">0</span>' +
          '<span class="kn-tk__unit">' + (L.entries || 'ENTR\u00C9ES') + '</span></div>' +
        rs3Line +
        '<div class="kn-tk__perf"></div>' +
        '<div class="kn-tk__foot"><span class="kn-tk__serial">' + serial + '</span><span class="kn-tk__barcode"></span></div>' +
        '<div class="kn-tk__cta" role="button" tabindex="0">' + (L.cta || 'AJOUT\u00C9 \u2014 FONCE AU CHECKOUT') + '</div>' +
        '<div class="kn-tk__spark"></div>' +
      '</div>';

    layer.innerHTML = '';
    layer.appendChild(card);

    requestAnimationFrame(function () { requestAnimationFrame(function () { card.classList.add('is-in'); }); });
    countUp(card.querySelector('.kn-tk__val'), t.entries);
    if (!reduce) sparks(card.querySelector('.kn-tk__spark'));
    if (CFG.sound) chime();

    var closed = false;
    function close() {
      if (closed) return; closed = true;
      card.classList.remove('is-in');
      setTimeout(function () { if (card.parentNode) card.parentNode.removeChild(card); busy = false; }, 500);
    }
    function go() { close(); if (typeof window.knOpenCart === 'function') window.knOpenCart(); }

    card.querySelector('.kn-tk__x').addEventListener('click', close);
    card.querySelector('.kn-tk__glow').addEventListener('click', close);
    var cta = card.querySelector('.kn-tk__cta');
    cta.addEventListener('click', go);
    cta.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') go(); });
    document.addEventListener('keydown', function esc2(e) { if (e.key === 'Escape') { close(); document.removeEventListener('keydown', esc2); } });

    var auto = setTimeout(close, 4500);
    card.addEventListener('mouseenter', function () { clearTimeout(auto); });
    card.querySelector('.kn-tk__name').addEventListener('focus', function () { clearTimeout(auto); });
  }

  /* -------- Compteur qui monte -------- */
  function countUp(el, target) {
    if (!el) return;
    if (reduce) { el.textContent = fmt(target); return; }
    var dur = 900, t0 = performance.now();
    (function step(now) {
      var p = Math.min(1, (now - t0) / dur);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(Math.round(target * e));
      if (p < 1) requestAnimationFrame(step);
    })(t0);
  }

  /* -------- Étincelles -------- */
  function sparks(host) {
    if (!host) return;
    var colors = ['#F5C518', '#ffffff', '#E10600', '#ffd966'];
    for (var i = 0; i < 16; i++) {
      var s = document.createElement('i');
      var a = Math.random() * Math.PI * 2, d = 42 + Math.random() * 78;
      s.style.setProperty('--tx', (Math.cos(a) * d).toFixed(0) + 'px');
      s.style.setProperty('--ty', (Math.sin(a) * d).toFixed(0) + 'px');
      s.style.background = colors[i % colors.length];
      s.style.animationDelay = (Math.random() * 0.12).toFixed(2) + 's';
      host.appendChild(s);
    }
    setTimeout(function () { host.innerHTML = ''; }, 1100);
  }

  /* -------- Petit "cha-ching" synthétisé (aucun fichier audio requis) -------- */
  function chime() {
    try {
      var AC = window.AudioContext || window.webkitAudioContext; if (!AC) return;
      var ctx = new AC();
      [880, 1320, 1760].forEach(function (f, i) {
        var o = ctx.createOscillator(), g = ctx.createGain();
        o.type = 'triangle'; o.frequency.value = f;
        o.connect(g); g.connect(ctx.destination);
        var t = ctx.currentTime + i * 0.075;
        g.gain.setValueAtTime(0.0001, t);
        g.gain.exponentialRampToValueAtTime(0.16, t + 0.02);
        g.gain.exponentialRampToValueAtTime(0.0001, t + 0.34);
        o.start(t); o.stop(t + 0.35);
      });
      setTimeout(function () { try { ctx.close(); } catch (e) {} }, 1200);
    } catch (e) {}
  }

  /* -------- Utils -------- */
  function fmt(n) { try { return n.toLocaleString(CFG.locale === 'en' ? 'en-CA' : 'fr-CA'); } catch (e) { return '' + n; } }
  function esc(s) { var d = document.createElement('div'); d.textContent = (s == null ? '' : s); return d.innerHTML; }
})();